define('views/modules/feedback/feedback',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // services
    'services/events/conversation-events',
    'services/user',
    // views
    'views/modules/calendar/calendar-item-panel-content',
    'views/parts/alert/alert-list',
    'views/modules/feedback/blocks/feeling',
    'views/modules/feedback/blocks/comment',
    // collections
    'collections/member/supervisors',
    'collections/conversation/conversations',
    // templates
    'text!templates/modules/feedback/feedback.html'
], function(
    // Libs
    _, Backbone, Mustache, moment, U,
    // services
    ConversationEvents,
    User,
    // Views
    VCalendarItemPanelContent,
    VAlertList,
    VFeedbackFeeling,
    VFeedbackComment,
    // collections
    Supervisors,
    CConversations,
    // Templates
    TFeedback
) {

    var VFeedback = VCalendarItemPanelContent.extend({
        contentTemplate: TFeedback,
        fields: VCalendarItemPanelContent.prototype.fields.concat(['feedback_level', 'feedback_comment']),

        regions: _.extend({}, VCalendarItemPanelContent.prototype.regions, {
            alert: ".feedback-alert",
            feeling: ".feedback-feeling",
            comment: ".feedback-comment",
        }),

        initialize: function(opt) {
            VFeedback.__super__.initialize.call(this, opt);

            _.extend(this, {
                profile: opt.profile,
                role: opt.role
            });

            var model = this.model,
                conversations = this.conversations = new CConversations(),
                view = _.extend(this.view, {
                    feeling: new VFeedbackFeeling({ model: model }),
                    comment: new VFeedbackComment({
                        model: model,
                        modelMaster: this.modelMaster,
                    }),
                    alert: new VAlertList(),
                });

            this.listenTo(model, { "model:reset": this.onModelReset });
        },

        render: function() {
            VFeedback.__super__.render.call(this);

            var view = this.view,
                zone = this.zone;

            this.assign(view.alert, zone.$alert)
                .assign(view.feeling, zone.$feeling)
                .assign(view.comment, zone.$comment);

            this.updateWarning();

            return this;
        },

        updateWarning: function() {
            var view = this.view,
                model = this.model,
                isFuture = !model.hasPassed(),
                isNotDone = !model.isDone();

            view.alert.reset();

            if (isFuture) {
                view.alert.addInfo("messages:message-feedback-future");
            } else if (!isFuture && isNotDone) {
                view.alert.addInfo("messages:message-feedback-not-done");
            }

            view.feeling.toggleDisabled(isFuture || isNotDone);
        },

        ////////////
        // events //
        ////////////
        onModelReset: function() {
            this.updateWarning();
        },

        onSubmit: function() {
            if (!this.model.hasPassed()) {
                return false; // can't save feedback on a future activity.
            }

            this.view.feeling.onSubmit();
        },

        onSuccess: function() {
            var item = this.model,
                conversationAttrs = _.extend({}, {
                    message: item.getFeedbackComment(),
                    type: 'feedback',
                    activity: item.id
                });

            if (item.hasComment() && item.getFeedbackComment() !== this.modelMaster.getFeedbackComment()) {
                if (this.role === 'supervisor') {
                    // sending feedback message to the current client only (profile)
                    this.conversations.add(
                        _.extend(conversationAttrs, {
                            user: User.getCurrentlySelectedUser().id
                        }), { sort: false });
                } else {
                    // sending feedback message to all supervisors of the client
                    Supervisors.each(function(supervisor) {
                        this.conversations.add(
                            _.extend(conversationAttrs, {
                                user: supervisor.id
                            }), { sort: false });
                    }, this);
                }

                this.conversations.bulkCreate({
                    success: this.onFeedbackSent,
                    context: this
                });
            }
            VFeedback.__super__.onSuccess.apply(this, arguments);
        },

        onFeedbackSent: function(response) {
            this.conversations.reset();
            ConversationEvents.feedbackSentToSupervisors(new CConversations(response.collection, { sort: false }));
        },

    });

    return VFeedback;

});

